import Vue from 'vue'
import Router from "vue-router"
Vue.use(Router)
let router = new Router({
	routes: [{
		path: "*",
		redirect: '/login'
	},{
		path: '/login',
		component: () => import('../view/login/login.vue'),
	},
	{
		path: "/loading",
		component: () => import('../view/loading/loading.vue'),
	},
	{
		path:'/applyForTrial',
		component:()=>import('../view/login/applyForTrial.vue')
	},
	{
		path:'/worklogin',
		component:()=> import('../view/loading/worklogin.vue')
	},
	{
		path:'/error',
		component:()=> import('../view/loading/error.vue')
	},
	{
		path:'/error500',
		component:()=>import('../view/loading/error500.vue')
	}
	],
	mode: 'history'
})
export default router
